<template>
  <div class="">
    <v-dialog
      class="popbox"
      name="dialog2"
      v-model="isShow"
      :title="type === 'add' ? '参数新增' : '参数更新'"
      close-on-click-modal
      :modal="true"
      :width="668"
      @open="open"
      @after-close="handleAfterClose"
      @confirm="handleConfirm"
    >
      <v-form ref="form" :model="ruleForm" :rules="rules">
        <v-form-item prop="name">
          <template slot="label">
            <span class="required">*</span>
            <span>字段名称</span>
          </template>
          <v-input type="text" name="name" v-model="ruleForm.name"></v-input>
        </v-form-item>

        <v-form-item prop="identifier">
          <template slot="label">
            <span class="required">*</span>
            <span>字段标识</span>
          </template>
          <v-input
            type="text"
            name="identifier"
            v-model="ruleForm.identifier"
          ></v-input>
        </v-form-item>
        <v-form-item prop="data_type">
          <template slot="label">
            <span class="required">*</span>
            <span>数据类型</span>
          </template>
          <v-select
            id="data_type"
            name="data_type"
            v-model="ruleForm.data_type"
            :options="dataTypeOptins"
          ></v-select>
        </v-form-item>

        <!-- <v-form-item prop="unit"  :required="false">
            <template slot="label">
              <span class="required"></span>
              <span>单位</span>
            </template>
            <v-input type="text" name="unit" v-model="ruleForm.unit"></v-input>
          </v-form-item> -->
      </v-form>
      <v-loading
        class="loading-box"
        :visible="!upTips"
        name="loading4"
      ></v-loading>
    </v-dialog>
  </div>
</template>

<script>
import { copy } from "@/common/libs/utils";

export default {
  components: {},
  props: {
    showInputDialog: {
      type: Boolean,
      default: false,
    },
    row: {}, // 编辑原始数据
    list: {}, // 新增时需要上传所有数据
    type: {}, // 用来判断是新增还是修改
    topicId: {}, // 接口需要
    category: {}, // 接口需要
  },
  data() {
    return {
      rules: {
        name: copy([
          {
            type: "nameInput",
          },
        ]),
        identifier: copy([
          {
            type: "identifier",
          },
        ]),
      },
      ruleForm: {
        name: "",
        identifier: "",
        data_type: "",
        // unit: ''
      },
      dataTypeOptins: [
        {
          label: "int(整数)",
          value: "int",
        },
        {
          label: "float64(浮点数)",
          value: "float64",
        },
        {
          label: "string(字符串)",
          value: "string",
        },
        {
          label: "bool(布尔值)",
          value: "bool",
        },
        {
          label: "array(数组)",
          value: "array",
        },
        {
          label: "struct(结构)",
          value: "struct",
        },
      ],
      isShow: false,
      upTips: true,
      nameRepeat: false,
      identifierRepeat: false,
      nodata: {},
    };
  },
  created() {},

  watch: {
    showInputDialog(newVal) {
      this.isShow = newVal;
    },
  },
  methods: {
    open() {
      this.nodata = copy(this.ruleForm);
      if (this.type == "edit") {
        console.log(this.row);
        this.ruleForm = this.row;
      }
    },
    async handleConfirm() {
      const valid = this.$refs.form.submitForm();
      if (valid === false) {
        return;
      }
      this.nameRepeat = false;
      this.identifierRepeat = false;
      this.list.map((item) => {
        if (item.name == this.ruleForm.name) {
          if (
            this.type === "add" ||
            (this.type === "edit" && item.id !== this.ruleForm.id)
          ) {
            this.nameRepeat = true;
          }
        }
        if (item.identifier == this.ruleForm.identifier) {
          if (
            this.type === "add" ||
            (this.type === "edit" && item.id !== this.ruleForm.id)
          ) {
            this.identifierRepeat = true;
          }
        }
      });
      if (this.nameRepeat == true) {
        this.$message.error("参数名称已添加不能重复");
        return;
      }
      if (this.identifierRepeat == true) {
        this.$message.error("标识符已添加不能重复");
        return;
      }
      if (this.type === "add") {
        const submitData = {
          category: this.category,
          topic_id: this.topicId,
          [this.category + "_data"]: [...this.list, this.ruleForm],
        };

        const { code, msg } = await this.$post(
          "/td/td-iot-api/iot/topic/param/v1",
          submitData
        );
        if (code === 0) {
          this.$emit("change");
          this.$emit("update:showInputDialog", false);
          Object.assign(this.$data, this.$options.data());
        } else {
          this.$message.error(msg);
        }
      }
      if (this.type === "edit") {
        const { ID, data_type, identifier, name } = this.ruleForm;
        const submitData = {
          data_type,
          id: ID,
          identifier,
          name,
        };
        const { code, msg } = await this.$put(
          "/td/td-iot-api/iot/topic/param/v1",
          submitData
        );
        if (code === 0) {
          this.$emit("change");
          this.$emit("update:showInputDialog", false);
          Object.assign(this.$data, this.$options.data());
        } else {
          this.$message.error(msg);
        }
      }
    },
    handleAfterClose() {
      this.$emit("update:showInputDialog", false);
      Object.assign(this.$data, this.$options.data());
    },
  },
  beforeDestroy() {},
};
</script>

<style lang="scss" scoped>
::v-deep {
  .v-dialog {
    max-height: 120%;
  }
}
</style>

